<template>
  <div class="error-404-container">
    <div class="error-404-container__img"></div>
    <div class="error-404-container__tips">抱歉，您访问的页面不存在。</div>
    <!-- <el-button type="primary" @click="errorClick">返回首页</el-button> -->
  </div>
</template>

<script setup>
// #region 引用
// import router from '@/routers';
// #endregion

// #region props/emit
// #endregion

// #region 变量/常量

// #endregion

// #region 业务方法

// #endregion

// #region 生命周期
/**
 * 错误点击事件处理函数
 *
 * @returns 无返回值
 */
// const errorClick = () => {
//   router.push('/');
// };
// #endregion
</script>

<style lang="scss" scoped>
.error-404-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}

.error-404-container > .error-404-container__img {
  width: 350px;
  height: 350px;
  background-image: url('@/views/empty/error/assets/images/404.svg');
  background-repeat: no-repeat;
}

.error-404-container > .error-404-container__tips {
  font-size: var(--el-font-size-large);
  color: var(--el-color-info);
}

.error-404-container > .el-button {
  margin-top: 20px;
  font-size: var(--el-font-size-medium);
}
</style>
